
import Vue from "vue";
import { Component, Inject, Prop } from "vue-property-decorator";
import Repeater from "@/components/Reusable/CustomInputs/Repeater/Repeater.vue";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import { MediaSizeOptions } from "@/types/media";
import { ElementStudioContext } from "@/components/ElementStudio/ElementStudioTabsAndPanels.vue";

@Component({
  components: { DropdownInput, Repeater }
})
export default class ElementStudioMediaSizeOptions extends Vue {
  @Inject("context") readonly context!: ElementStudioContext;

  @Prop()
  value?: MediaSizeOptions;

  get internalValue() {
    return this.value || {};
  }

  get paths() {
    return this.context.getPathsToAllControls(["wpmedia"]);
  }

  updatePath(path: string) {
    this.emit({
      ...this.internalValue,
      imagePropertyPath: path || ""
    });
  }

  toggleSrcset(disableSrcset: boolean) {
    this.emit({
      ...this.internalValue,
      disableSrcset
    });
  }

  emit(mediaOptions: MediaSizeOptions) {
    this.$emit("input", mediaOptions);
  }
}
